<!-- show a loading screen -->
@if (!restaurant) {
  <div class="restaurant-loader">
    <div class="loader">
      <fa-icon [icon]="faUtensils" [animation]="'spin'" size="lg"></fa-icon>
    </div>
  </div>
}

@if (restaurant) {
  <div class="restaurant">
    <!-- Upper navbar -->
    @if (selectedProduct) {
      <app-navbar class="custom-navbar" [restaurant]="restaurant" [canGoBack]="selectedProduct" (onBack)="backTriggered()"></app-navbar>
    }
    <!-- Open hours -->
    @if (restaurant && !selectedProduct) {
      <app-open-hours [company]="restaurant"></app-open-hours>
    }
    @if (!selectedProduct) {
      <div class="px-2 ct-container">
        <div class="ct-main-content">
          <!-- Pcategories list -->
          <div class="pcategories-list" [class.sticky]="scrollY > 40">
            @for (pcategory of pcategories; track pcategory; let i = $index) {
              <span class="badge badge-secondary pcategory-badge" [class.active-badge]="pcategory.is_active" (click)="scrollToPcategory(pcategory, i)">{{pcategory.delivery_name || pcategory.name}}</span>
            }
          </div>
          <!-- Product search bar -->
          <div class="product-search">
            <div class="input-group">
              <input type="text" placeholder="Nome do item..." class="form-control" [(ngModel)]="product_name_search"/>
              <button class="btn btn-md btn-primary input-group-addon search-button">
                <fa-icon [icon]="faSearch"></fa-icon>
              </button>
            </div>
          </div>
          @for (pcategory of pcategories; track pcategory) {
            <app-products-list  id="pcat-{{pcategory.id}}" [pcategory]="pcategory" [productNameSearch]="product_name_search" (onBack)="backToMenu()" (onProductSelected)="selectProduct($event)">
            </app-products-list>
          }
        </div>
      </div>
    }
    @if (selectedProduct) {
      <app-product-details
        [product]="selectedProduct"
        (onItemAdded)="onItemAdded($event)"
        [isPizza]="isPizza"
        [pizzaConfig]="restaurant.parsedPizzaConfig"
        [pizzaCategories]="pizzaCategories">
      </app-product-details>
    }
  </div>
}
@if (restaurant) {
  <app-bottom-navbar [company]="restaurant"></app-bottom-navbar>
}
@if (pcategories && pcategoriesOffset) {
  <app-scroll-top (onScroll)="pageScroll($event)" (onScrollFinished)="stoppedScrolling()"></app-scroll-top>
}